<template>
  <div class="charisma-location-receipt-details">
    <general-top-bar :title="$t('reports.charismaLocationReceipt')"></general-top-bar>
    <div class="col-md-12 card text-left">
      <div class="card-header" style="display:flex; justify-content: space-between; align-items:center;">
        <div>
          <p class="d-inline-flex">
            <a class="btn btn-orange back" @click.prevent="goBackToReport">
              {{ $t('general.back') }}
            </a>
          </p>
        </div>
        <div>
          <div class="text-right">
            <p class="d-inline-flex">
              <button
                type="submit"
                class="btn btn-success btn-icon mar-rt-10 save"
                @click.prevent="sendFiscalZReports"
                :disabled="!zReports || zReports.length === 0"
                :title="$t('reports.sendReceipts')">
                {{ $t('reports.sendReceipts') }}
              </button>
            </p>
          </div>
        </div>
      </div>

      <div class="card-content filters-card">
        <div class="row">
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.location') }}</label>
            <el-select
              v-model="filters.locationId"
              filterable
              clearable
              disabled
              :placeholder="$t('general.select')"
              style="width: 100%">
              <el-option
                v-for="location in locations"
                :key="location.id"
                :label="location.name"
                :value="location.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.posIds') }}</label>
            <el-select
              v-model="filters.posIds"
              multiple
              filterable
              clearable
              disabled
              :placeholder="$t('general.select')"
              style="width: 100%">
              <el-option
                v-for="pos in posOptions"
                :key="pos.value"
                :label="pos.label"
                :value="pos.value">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.partnerCode') }}</label>
            <el-input
              v-model="filters.partnerCode"
              disabled
              :placeholder="$t('charisma.partnerCode')">
            </el-input>
          </div>
        </div>
        <div class="row mar-to-15">
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.categoryAdministration') }}</label>
            <el-select
              v-model="filters.administrationId"
              filterable
              clearable
              disabled
              :placeholder="$t('general.select')"
              style="width: 100%">
              <el-option
                v-for="admin in administrations"
                :key="admin.id"
                :label="admin.name"
                :value="admin.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.itemId') }}</label>
            <el-input
              v-model="filters.itemId"
              disabled
              :placeholder="$t('charisma.itemId')">
            </el-input>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ $t('charisma.tipsItemId') }}</label>
            <el-input
              v-model="filters.tipsItemId"
              disabled
              :placeholder="$t('charisma.tipsItemId')">
            </el-input>
          </div>
        </div>
        <div class="row mar-to-15">
          <div class="col-md-12">
            <p class="pull-left">
              <el-date-picker
                type="daterange"
                v-model="dateRange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :name="pickerNames"
                :picker-options="pickerOptions">
              </el-date-picker>
              <p class="pull-left"
                style="display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-left: 10px;"
              >
                {{$t('general.from')}}
                <el-time-select
                  :placeholder="$t('catalogProd.timePlaceholder')"
                  v-model="data_from_time"
                  style="margin-left: 10px;"
                  :change="changeValidFrom()"
                  class="mar-rt-5"
                  :picker-options="{
                    start: '00:00',
                    step: '00:10',
                    end: '24:00'
                  }">
                </el-time-select>
                {{$t('general.to')}}
                <el-time-select
                  :placeholder="$t('catalogProd.timePlaceholder')"
                  v-model="data_to_time"
                  :change="changeValidFrom()"
                  class="mar-lt-5"
                  :picker-options="{
                    start: '00:00',
                    step: '00:10',
                    end: '24:00'
                  }">
                </el-time-select>
              </p>
              <div class="pull-left search-button-reports">
                <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
              </div>
            </p>
          </div>
        </div>
      </div>

      <div class="card-content">
        <data-tables-server
          @query-change="paginationChanged"
          v-loading="loading"
          :data="zReports"
          :total="totalZReports"
          :pagination-props="paginationProps"
          :empty-text="$t('reports.noDataAvailable')"
          style="width: 100%">
          <el-table-column prop="id" :label="$t('fiscalZ.id')" min-width="60"></el-table-column>
          <el-table-column prop="z_number" :label="$t('fiscalZ.zNumber')" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.z_number || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="z_timestamp" :label="$t('fiscalZ.zTimestamp')" min-width="150">
            <template slot-scope="scope">
              {{ formatDate(scope.row.z_timestamp) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales_a" :label="$t('fiscalZ.totalSalesA')" min-width="135">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales_a) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales_b" :label="$t('fiscalZ.totalSalesB')" min-width="135">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales_b) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales_c" :label="$t('fiscalZ.totalSalesC')" min-width="135">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales_c) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales_d" :label="$t('fiscalZ.totalSalesD')" min-width="135">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales_d) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales_e" :label="$t('fiscalZ.totalSalesE')" min-width="135">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales_e) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_other_taxes" :label="$t('fiscalZ.totalOtherTaxes')" min-width="140">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_other_taxes) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_exempt" :label="$t('fiscalZ.totalVatExempt')" min-width="140">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_exempt) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_sales" :label="$t('fiscalZ.totalSales')" min-width="125">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_sales) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_a" :label="$t('fiscalZ.totalVatA')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_a) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_b" :label="$t('fiscalZ.totalVatB')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_b) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_c" :label="$t('fiscalZ.totalVatC')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_c) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_d" :label="$t('fiscalZ.totalVatD')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_d) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat_e" :label="$t('fiscalZ.totalVatE')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat_e) }}
            </template>
          </el-table-column>
          <el-table-column prop="total_vat" :label="$t('fiscalZ.totalVat')" min-width="120">
            <template slot-scope="scope">
              {{ formatMoney(scope.row.total_vat) }}
            </template>
          </el-table-column>
        </data-tables-server>
      </div>

      <div class="card-content" style="margin-top: 15px;">
        <div class="row">
          <div class="col-md-6">
            <label>{{ $t('charisma.dataTo') }}</label>
            <el-input type="textarea" :rows="10" readonly v-model="dataToTextarea" :placeholder="$t('charisma.dataTo')"></el-input>
          </div>
          <div class="col-md-6">
            <label>{{ $t('charisma.dataFrom') }}</label>
            <el-input type="textarea" :rows="10" readonly v-model="dataFromTextarea" :placeholder="$t('charisma.dataFrom')"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import moment from 'moment'
import {DatePicker, TimeSelect} from 'element-ui'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  name: 'CharismaLocationReceiptDetails',
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect
  },
  data () {
    return {
      loading: false,
      receipts: [],
      zReports: [],
      totalZReports: 0,
      dataToTextarea: '',
      dataFromTextarea: '',
      locations: [],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      administrations: [],
      posList: [],
      filters: {
        locationId: null,
        posIds: [],
        partnerCode: this.$route.query.partnerCode || '',
        administrationId: this.$route.query.administrationId ? Number(this.$route.query.administrationId) : null,
        itemId: this.$route.query.itemId || '',
        tipsItemId: this.$route.query.tipsItemId || ''
      },
      timezone: (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest',
      dateRange: [
        moment().subtract(1, 'days').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      data_from_time: '05:00',
      data_to_time: '05:00',
      pickerNames: ['data_from', 'data_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      }
    }
  },
  computed: {
    posOptions () {
      return (this.posList || []).map(pos => ({
        value: pos.id,
        label: pos.name || pos.id
      }))
    }
  },
  created () {
    this.initLocations()
    this.initAdministrations()
    this.initPosList()
    this.fetchLocationReceiptDetails()
  },
  methods: {
    goBackToReport () {
      const query = Object.assign({}, this.$route.query, { tab: 'charisma-location-receipt' })
      this.$router.push({ path: '/reports', query })
    },
    fetchLocationReceiptDetails (query) {
      const locationId = this.$route.params.locationId
      if (!locationId) {
        return
      }

      // Prepare date/time filters
      let dataFrom = null
      let dataTo = null
      if (this.dateRange && this.dateRange.length === 2 && this.data_from_time && this.data_to_time) {
        // Handle 24:00 as 23:59
        let fromTime = this.data_from_time === '24:00' ? '23:59' : this.data_from_time
        let toTime = this.data_to_time === '24:00' ? '23:59' : this.data_to_time
        dataFrom = this.dateRange[0] + ' ' + fromTime
        dataTo = this.dateRange[1] + ' ' + toTime
      }

      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      // Add date filters to payload if they exist
      if (dataFrom) {
        payload.date_from = dataFrom
      }
      if (dataTo) {
        payload.date_to = dataTo
      }

      // Add pagination parameters
      const pageSize = query ? query.pageSize : (this.paginationProps.pageSize || 20)
      const page = query ? query.page : (this.paginationProps.currentPage || 1)
      const queryParams = `?page=${page}&perPage=${pageSize}`

      this.loading = true
      this.apiRequest(`/reports/v2/charisma/location-receipts/${locationId}${queryParams}`, 'GET', payload, response => {
        if (response && response.status) {
          const data = response.data || {}
          this.receipts = this.normalizeReceipts(data)
          this.populateFiltersFromResponse(data)

          // Extract Z reports from response (paginated structure)
          const zReportsData = data.today_fiscal_z_reports || response.today_fiscal_z_reports
          if (zReportsData && zReportsData.data && Array.isArray(zReportsData.data)) {
            this.zReports = zReportsData.data
            this.totalZReports = zReportsData.total || 0
            this.paginationProps.currentPage = zReportsData.current_page || page
            this.paginationProps.pageSize = zReportsData.per_page || pageSize
          } else if (zReportsData && Array.isArray(zReportsData)) {
            // Fallback for old structure if needed
            this.zReports = zReportsData
            this.totalZReports = zReportsData.length
          } else {
            this.zReports = []
            this.totalZReports = 0
          }

          // Extract logs data for textareas
          const logs = data.today_charisma_location_receipt_logs || response.today_charisma_location_receipt_logs || []
          if (Array.isArray(logs) && logs.length > 0) {
            const dataToValues = logs
              .map(log => log.data_to)
              .filter(val => val !== undefined && val !== null && val !== '')
              .map(val => {
                if (typeof val === 'object') {
                  return JSON.stringify(val, null, 2)
                }
                return String(val)
              })
            const dataFromValues = logs
              .map(log => log.data_from)
              .filter(val => val !== undefined && val !== null && val !== '')
              .map(val => {
                if (typeof val === 'object') {
                  return JSON.stringify(val, null, 2)
                }
                return String(val)
              })
            this.dataToTextarea = dataToValues.join('\n-------------\n')
            this.dataFromTextarea = dataFromValues.join('\n-------------\n')
          } else {
            this.dataToTextarea = ''
            this.dataFromTextarea = ''
          }
        } else {
          this.receipts = []
          this.zReports = []
          this.totalZReports = 0
          this.dataToTextarea = ''
          this.dataFromTextarea = ''
          swal(
            '',
            response && response.errors && response.errors.id ? response.errors.id : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    initLocations () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      const setLocations = (locationSource = []) => {
        let normalized = Array.isArray(locationSource)
          ? locationSource.map(location => ({
            id: this.normalizeSelectableValue(location.true_id || location.location_id || location.id),
            name: location.name
          }))
          : []

        const role = this.$session.get('userDataRole')
        if (['USER', 'LOCATION_ADMIN', 'LOCATION_STORE_ADMIN'].includes(role)) {
          let allowedLocations = []
          try {
            allowedLocations = JSON.parse(this.$session.get('userDataLocations') || '[]')
          } catch (err) {
            allowedLocations = []
          }
          if (!allowedLocations.length) {
            allowedLocations = normalized.map(loc => loc.id)
          }
          normalized = normalized.filter(loc => allowedLocations.includes(loc.id))
        }

        this.locations = normalized
      }

      if (Array.isArray(sessionData.locations_details) && sessionData.locations_details.length) {
        setLocations(sessionData.locations_details)
        return
      }

      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'true_id', 'name', 'location_id']
      }

      this.apiRequest('/locations', 'GET', payload, response => {
        if (response && response.status && Array.isArray(response.data)) {
          sessionData.locations_details = response.data
          this.$session.set('selectedCompanyData', sessionData)
          setLocations(response.data)
        } else {
          this.locations = []
        }
      })
    },
    initAdministrations () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      const parseStoredList = value => {
        if (Array.isArray(value)) {
          return value
        }
        if (!value) {
          return []
        }
        try {
          return JSON.parse(value)
        } catch (err) {
          return []
        }
      }
      const cachedAdministrations = Array.isArray(sessionData.administrations) && sessionData.administrations.length
        ? sessionData.administrations
        : parseStoredList(this.$session.get('administrations'))
      if (Array.isArray(cachedAdministrations) && cachedAdministrations.length) {
        this.administrations = cachedAdministrations
        return
      }
      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/administration', 'GET', payload, response => {
        if (response && response.status && Array.isArray(response.data)) {
          this.administrations = response.data
          sessionData.administrations = response.data
          this.$session.set('selectedCompanyData', sessionData)
          this.$session.set('administrations', response.data)
        } else {
          this.administrations = []
        }
      })
    },
    initPosList () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      const parseStoredList = value => {
        if (Array.isArray(value)) {
          return value
        }
        if (!value) {
          return []
        }
        try {
          return JSON.parse(value)
        } catch (err) {
          return []
        }
      }
      const cachedPos = Array.isArray(sessionData.compact_pos_list) && sessionData.compact_pos_list.length
        ? sessionData.compact_pos_list
        : parseStoredList(this.$session.get('compact_pos_list'))
      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (Array.isArray(cachedPos) && cachedPos.length) {
        this.posList = cachedPos
        return
      }
      this.apiRequest('/pos-admin/compact-list', 'GET', payload, response => {
        if (response && response.status && Array.isArray(response.data)) {
          this.posList = response.data
          sessionData.compact_pos_list = response.data
          this.$session.set('selectedCompanyData', sessionData)
          this.$session.set('compact_pos_list', response.data)
        } else {
          this.posList = []
        }
      })
    },
    populateFiltersFromResponse (data) {
      if (!data || typeof data !== 'object') {
        return
      }
      const location = data.location || {}
      const meta = data.meta || data.configuration || {}
      const fallback = data.data || data || {}

      const pickValue = (...values) => {
        for (const val of values) {
          if (val !== undefined && val !== null && val !== '') {
            return val
          }
        }
        return undefined
      }

      const locationId = pickValue(this.filters.locationId, location.true_id, location.location_id, location.id)
      if (locationId === undefined) {
        const fallbackLocationId = pickValue(fallback.true_id, fallback.location_id, fallback.id)
        if (fallbackLocationId !== undefined) {
          this.filters.locationId = this.normalizeSelectableValue(fallbackLocationId)
        }
      } else {
        this.filters.locationId = this.normalizeSelectableValue(locationId)
      }

      const partnerCode = pickValue(this.filters.partnerCode, location.partner_code, meta.partner_code, fallback.partner_code)
      if (partnerCode !== undefined) {
        this.filters.partnerCode = partnerCode
      }

      const administrationId = pickValue(
        this.filters.administrationId,
        location.administration_id,
        location.administration && location.administration.id,
        location.administrationId,
        fallback.administration_id,
        fallback.administration && fallback.administration.id,
        fallback.administrationId
      )
      if (administrationId !== undefined) {
        this.filters.administrationId = Number(administrationId) || administrationId
      }

      const itemId = pickValue(
        this.filters.itemId,
        location.item_id,
        location.itemId,
        meta.item_id,
        meta.itemId,
        fallback.item_id,
        fallback.itemId
      )
      if (itemId !== undefined) {
        this.filters.itemId = itemId
      }

      const tipsItemId = pickValue(
        this.filters.tipsItemId,
        location.tips_item_id,
        location.tipsItemId,
        meta.tips_item_id,
        meta.tipsItemId,
        fallback.tips_item_id,
        fallback.tipsItemId
      )
      if (tipsItemId !== undefined) {
        this.filters.tipsItemId = tipsItemId
      }

      const posIds = pickValue(
        location.pos_ids,
        location.posIds,
        meta.pos_ids,
        meta.posIds,
        fallback.pos_ids,
        fallback.posIds
      )
      if (Array.isArray(posIds)) {
        this.filters.posIds = posIds
          .filter(id => id !== undefined && id !== null && id !== '')
          .map(id => this.normalizeSelectableValue(id))
      }
    },
    normalizeReceipts (payload) {
      if (Array.isArray(payload)) {
        return payload
      }
      if (Array.isArray(payload.receipts)) {
        return payload.receipts
      }
      if (Array.isArray(payload.table_data)) {
        return payload.table_data
      }
      if (payload.data && Array.isArray(payload.data)) {
        return payload.data
      }
      return []
    },
    formatMoney (amount) {
      const numeric = Number(amount || 0)
      if (this.formatMoneyAmount) {
        return this.formatMoneyAmount(numeric)
      }
      return numeric.toFixed(2)
    },
    formatStatus (status) {
      if (status === null || status === undefined || status === '') {
        return '-'
      }
      return this.$t(`charisma.charisma${status}`) || status
    },
    formatDate (value) {
      if (!value) {
        return '-'
      }
      if (this.formatToCompanyTimezone) {
        return this.formatToCompanyTimezone(value, this.timezone)
      }
      return value
    },
    normalizeSelectableValue (value) {
      if (value === undefined || value === null || value === '') {
        return value
      }
      const numeric = Number(value)
      if (!Number.isNaN(numeric)) {
        return numeric
      }
      return value
    },
    changeValidFrom () {
      if (!this.data_from_time) {
        this.data_from_time = '05:00'
      }
      if (!this.data_to_time) {
        this.data_to_time = '05:00'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.fetchLocationReceiptDetails(query)
      if (query.type === 'size') this.fetchLocationReceiptDetails(query)
      if (query.type === 'sort') this.fetchLocationReceiptDetails(query)
    },
    updateData () {
      this.fetchLocationReceiptDetails()
    },
    sendFiscalZReports () {
      if (!this.zReports || this.zReports.length === 0) {
        return
      }

      const locationId = this.$route.params.locationId
      if (!locationId) {
        swal('', this.$t('validations.wentWrong'), 'error')
        return
      }

      const userData = JSON.parse(this.$session.get('userData') || '{}')
      const userId = userData.id

      if (!userId) {
        swal('', this.$t('validations.wentWrong'), 'error')
        return
      }

      // Extract ids from zReports
      const fiscalZReportIds = this.zReports.map(report => report.id).filter(id => id !== undefined && id !== null)

      if (fiscalZReportIds.length === 0) {
        swal('', this.$t('validations.wentWrong'), 'error')
        return
      }

      // Prepare date/time filters
      let dateFrom = null
      let dateTo = null
      if (this.dateRange && this.dateRange.length === 2 && this.data_from_time && this.data_to_time) {
        // Handle 24:00 as 23:59
        let fromTime = this.data_from_time === '24:00' ? '23:59' : this.data_from_time
        let toTime = this.data_to_time === '24:00' ? '23:59' : this.data_to_time
        dateFrom = this.dateRange[0] + ' ' + fromTime
        dateTo = this.dateRange[1] + ' ' + toTime
      }

      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: locationId,
        location_id: this.filters.locationId,
        user_id: userId,
        fiscal_z_report_ids: fiscalZReportIds
      }

      // Add date filters to payload if they exist
      if (dateFrom) {
        payload.date_from = dateFrom
      }
      if (dateTo) {
        payload.date_to = dateTo
      }

      this.loading = true
      this.apiRequest('/reports/v2/charisma/send-fiscal-z-report', 'POST', payload, response => {
        if (response && response.status) {
          swal('', this.$t('general.success') || 'Success', 'success')
          // Optionally refresh data
          this.fetchLocationReceiptDetails()
        } else {
          swal(
            '',
            response && response.errors && response.errors.id ? response.errors.id : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.charisma-location-receipt-details .card {
  margin-top: 15px;
}
.header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
}
.filters-card {
  background: #fbfcff;
  border-bottom: 1px solid #edf0f9;
}
.filters-card .form-label {
  font-weight: 600;
  color: #394b63;
  display: block;
  margin-bottom: 6px;
}
.charisma-location-receipt-details .el-table th > .cell {
  white-space: nowrap !important;
  word-break: keep-all !important;
}
.charisma-location-receipt-details .el-table thead th .cell {
  white-space: nowrap !important;
  word-break: keep-all !important;
  overflow: visible !important;
}
</style>





// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/CharismaLocationReceiptDetails.vue